import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import Login from './components/Login';
import Cadastro from './components/Cadastro';
import SignupPage from './components/SignupPage';
import TenantDiscoveryPage from './components/TenantDiscoveryPage';
import TenantContextSignupPage from './components/TenantContextSignupPage';
import TenantContextLoginPage from './components/TenantContextLoginPage';
import RecuperarSenha from './components/RecuperarSenha';
import RegistroResponsavel from './components/RegistroResponsavel';
import Sidebar from './components/Sidebar';
import PrivateRoute from './components/PrivateRoute';
import UsuariosList from './components/UsuariosList';
import UnidadesList from './components/UnidadesList';
import TipoUnidadesList from './components/TipoUnidadesList';
import TipoContratosList from './components/TipoContratosList';
import SeriesList from './components/SeriesList';
import ModalidadesList from './components/ModalidadesList';
import AlunosList from './components/AlunosList';
import EquipesList from './components/EquipesList';
import TurmasList from './components/TurmasList';
import MatriculasList from './components/MatriculasList';
import RelatoriosOperacionais from './components/RelatoriosOperacionais';
import AulasDadasList from './components/AulasDadasList';
import RelatorioMensal from './components/RelatorioMensal';
import RelatorioContabil from './components/RelatorioContabil';
import FornecedoresList from './components/FornecedoresList';
import CategoriasDespesaList from './components/CategoriasDespesaList';
import DespesasList from './components/DespesasList';
import ReceitasList from './components/ReceitasList';
import FluxoCaixa from './components/FluxoCaixa';
import FolhaPagamento from './components/FolhaPagamento';
import ParcelasList from './components/ParcelasList';
import FaturasOperacional from './components/FaturasOperacional';
import FaturasGestao from './components/FaturasGestao';
import ResponsaveisList from './components/ResponsaveisList';
import ResponsavelDashboard from './components/ResponsavelDashboard';
import ResponsavelFrequenciaDetalhe from './components/responsavel/ResponsavelFrequenciaDetalhe';
import AcessoNegado from './components/AcessoNegado';
import TenantLifecycleBlocked from './components/TenantLifecycleBlocked';
import PerfisList from './components/PerfisList';
import DashboardExecutivo from './components/DashboardExecutivo';
import DashboardExecutivoV2 from './components/dashboardV2/DashboardExecutivoV2';
import DashboardOperacional from './components/DashboardOperacional';
import DashboardComercial from './components/DashboardComercial';
import DashboardRH from './components/DashboardRH';
import DashboardFinanceiroDetalhado from './components/DashboardFinanceiroDetalhado';
import DashboardUnidades from './components/DashboardUnidades';
import DashboardParcelas from './components/DashboardParcelas';
import PlatformDashboard from './components/platform/PlatformDashboard';
import PlatformTenantDetail from './components/platform/PlatformTenantDetail';
import PlatformSaasBillingCatalog from './components/platform/PlatformSaasBillingCatalog';
import PlatformRuntimeHistory from './components/platform/PlatformRuntimeHistory';
import PlatformRuntimeExecutionDetail from './components/platform/PlatformRuntimeExecutionDetail';
import PlatformRuntimeSearch from './components/platform/PlatformRuntimeSearch';
import PlatformRuntimeIncidentsPage from './components/platform/PlatformRuntimeIncidentsPage';
import PlatformRuntimeCockpit from './components/platform/PlatformRuntimeCockpit';
import PlatformRuntimeRetryPreview from './components/platform/PlatformRuntimeRetryPreview';
import PlatformRuntimeProviderConfig from './components/platform/PlatformRuntimeProviderConfig';
import PlatformSubscriptionRequestsPage from './components/platform/PlatformSubscriptionRequestsPage';
import PlatformTenantTimelinePage from './components/platform/PlatformTenantTimelinePage';
import PlatformOperationalEventsPage from './components/platform/PlatformOperationalEventsPage';
import PlatformOperationalHealthPage from './components/platform/PlatformOperationalHealthPage';
import PlatformIamPage from './components/platform/PlatformIamPage';
import PlatformRecoveryOperationsConsole from './components/platform/PlatformRecoveryOperationsConsole';
import PlatformAlertCenterPage from './components/platform/PlatformAlertCenterPage';
import PlatformFeatureFlagsPage from './components/platform/PlatformFeatureFlagsPage';
import PlatformGoLiveReadinessPage from './components/platform/PlatformGoLiveReadinessPage';
import PlatformBillingOperationsPage from './components/platform/PlatformBillingOperationsPage';
import PlatformSaasSubscriptionsDashboard from './components/platform/PlatformSaasSubscriptionsDashboard';
import FinancialSettings from './components/FinancialSettings';
import ReceiptIssuerSettings from './components/ReceiptIssuerSettings';
import TenantAccountSubscriptionPage from './components/TenantAccountSubscriptionPage';
import TenantLifecycleBanner from './components/TenantLifecycleBanner';
import Home from './components/Home';
import ProfessorPortalHome from './components/professor/ProfessorPortalHome';
import ProfessorAulaPage from './components/professor/ProfessorAulaPage';
import AdminPresencasPage from './components/admin/AdminPresencasPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { VocabularyProvider } from './contexts/VocabularyContext';
import AlterarSenhaModal from './components/AlterarSenhaModal';
import './App.css';

const { Content } = Layout;


const AppContent = () => {
  const { isAuthenticated, loading, user, checkAuth } = useAuth();
  const location = useLocation();
  const isResponsavel = user?.role === 'RESPONSAVEL';
  const isProfessor = user?.role === 'PROFESSOR';
  const isPlatformAdmin = user?.is_platform_admin === true;
  const showSidebar = isAuthenticated && !isResponsavel;

  const publicRoutes = ['/login', '/cadastro', '/signup', '/encontrar-ambiente', '/recuperar-senha', '/registrar-responsavel'];
  const isTenantContextPublicRoute = /^\/t\/[^/]+\/(login|cadastro)\/?$/i.test(location.pathname);
  const isPublicRoute = publicRoutes.includes(location.pathname) || isTenantContextPublicRoute;
  const hasTenantContext = Boolean(user?.current_tenant_id);
  const shouldShowLifecycleBanner = Boolean(
    !isPublicRoute
    && isAuthenticated
    && user
    && !isPlatformAdmin
    && hasTenantContext
    && user?.tenant_access_allowed !== false
  );

  // Controle global de primeiro acesso/force_password_change
  const [showForcePwdModal, setShowForcePwdModal] = React.useState(false);
  const needsForcePwdChange = !!user && (user.force_password_change === true || user.primeiro_acesso === true);
  const isTenantLifecycleBlocked = Boolean(
    user
    && user.is_platform_admin !== true
    && user.tenant_access_allowed === false
  );

  React.useEffect(() => {
    if (isAuthenticated && needsForcePwdChange) {
      setShowForcePwdModal(true);
    } else {
      setShowForcePwdModal(false);
    }
  }, [isAuthenticated, needsForcePwdChange]);

  // Bloqueia tudo exceto modal de senha
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div>Carregando...</div>
      </div>
    );
  }

  if (isPublicRoute) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/encontrar-ambiente" element={<TenantDiscoveryPage />} />
        <Route path="/t/:tenant_slug/cadastro" element={<TenantContextSignupPage />} />
        <Route path="/t/:tenant_slug/login" element={<TenantContextLoginPage />} />
        <Route path="/recuperar-senha" element={<RecuperarSenha />} />
        <Route path="/registrar-responsavel" element={<RegistroResponsavel />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  if (!isAuthenticated && !isPublicRoute) {
    return <Navigate to="/login" replace />;
  }

  if (isTenantLifecycleBlocked) {
    return (
      <TenantLifecycleBlocked
        accessState={user?.tenant_access_state}
        blockingReason={user?.tenant_blocking_reason}
      />
    );
  }

  // BLOQUEIO GLOBAL: se precisa trocar senha, só mostra modal
  if (showForcePwdModal) {
    return (
      <AlterarSenhaModal
        visible={true}
        onClose={() => {}}
        useGenericEndpoint={true}
        onSuccess={async () => {
          await checkAuth();
          setShowForcePwdModal(false);
        }}
      />
    );
  }

  const defaultRedirect = isResponsavel
    ? '/responsavel/dashboard'
    : isPlatformAdmin
      ? '/platform'
      : isProfessor
        ? '/professor'
        : '/inicio';

  if (isResponsavel && (location.pathname.startsWith('/dashboard') || location.pathname === '/inicio')) {
    return <Navigate to="/responsavel/dashboard" replace />;
  }

  return (
    <Layout
      className={showSidebar ? 'app-shell--with-sidebar' : undefined}
      style={{ minHeight: '100vh' }}
    >
      {showSidebar && <Sidebar />}
      <Layout>
        <Content style={{ padding: showSidebar ? '24px' : 0 }}>
          {shouldShowLifecycleBanner ? <TenantLifecycleBanner user={user} /> : null}
          {/* ...rotas protegidas... */}
          <Routes>
            <Route path="/inicio" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/professor" element={<PrivateRoute allowedRoles={['PROFESSOR']}><ProfessorPortalHome /></PrivateRoute>} />
            <Route path="/professor/encontros/:encontroId/chamada" element={<PrivateRoute allowedRoles={['PROFESSOR']}><ProfessorAulaPage /></PrivateRoute>} />
            <Route path="/dashboard" element={<PrivateRoute allowedRoles={['ADMIN']}><DashboardExecutivo /></PrivateRoute>} />
            <Route path="/dashboard-operacional" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><DashboardOperacional /></PrivateRoute>} />
            <Route path="/dashboard-comercial" element={<PrivateRoute allowedRoles={['ADMIN', 'RH']}><DashboardComercial /></PrivateRoute>} />
            <Route path="/dashboard-rh" element={<PrivateRoute allowedRoles={['ADMIN', 'RH']}><DashboardRH /></PrivateRoute>} />
            <Route path="/dashboard-financeiro" element={<PrivateRoute allowedRoles={['ADMIN', 'RH']}><DashboardFinanceiroDetalhado /></PrivateRoute>} />
            <Route path="/dashboard-parcelas" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><DashboardParcelas /></PrivateRoute>} />
            <Route path="/dashboard-unidades" element={<PrivateRoute allowedRoles={['ADMIN']}><DashboardUnidades /></PrivateRoute>} />
            <Route path="/responsaveis/pendentes" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><ResponsaveisList /></PrivateRoute>} />
            <Route path="/usuarios" element={<PrivateRoute allowedRoles={['ADMIN']}><UsuariosList /></PrivateRoute>} />
            <Route path="/unidades" element={<PrivateRoute allowedRoles={['ADMIN', 'RH']}><UnidadesList /></PrivateRoute>} />
            <Route path="/tipo-unidades" element={<PrivateRoute allowedRoles={['ADMIN', 'RH']}><TipoUnidadesList /></PrivateRoute>} />
            <Route path="/tipo-contratos" element={<PrivateRoute allowedRoles={['ADMIN', 'RH']}><TipoContratosList /></PrivateRoute>} />
            <Route path="/series" element={<PrivateRoute allowedRoles={['ADMIN', 'RH']}><SeriesList /></PrivateRoute>} />
            <Route path="/modalidades" element={<PrivateRoute allowedRoles={['ADMIN', 'RH']}><ModalidadesList /></PrivateRoute>} />
            <Route path="/alunos" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><AlunosList /></PrivateRoute>} />
            <Route path="/equipe" element={<PrivateRoute allowedRoles={['ADMIN', 'RH']}><EquipesList /></PrivateRoute>} />
            <Route path="/turmas" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE', 'ALUNO', 'PROFESSOR']}><TurmasList /></PrivateRoute>} />
            <Route path="/matriculas" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE', 'ALUNO']}><MatriculasList /></PrivateRoute>} />
            <Route path="/relatorios-operacionais" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><RelatoriosOperacionais /></PrivateRoute>} />
            <Route path="/aulas-dadas" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'PROFESSOR']}><AulasDadasList /></PrivateRoute>} />
            <Route path="/relatorio-mensal" element={<PrivateRoute><RelatorioMensal /></PrivateRoute>} />
            <Route path="/fornecedores" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><FornecedoresList /></PrivateRoute>} />
            <Route path="/categorias-despesa" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><CategoriasDespesaList /></PrivateRoute>} />
            <Route path="/despesas" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><DespesasList /></PrivateRoute>} />
            <Route path="/receitas" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><ReceitasList /></PrivateRoute>} />
            <Route path="/parcelas" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><ParcelasList /></PrivateRoute>} />
            <Route path="/faturas" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><Navigate to="/faturas/operacional" replace /></PrivateRoute>} />
            <Route path="/faturas/operacional" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><FaturasOperacional /></PrivateRoute>} />
            <Route path="/faturas/gestao" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><FaturasGestao /></PrivateRoute>} />
            <Route path="/fluxo-caixa" element={<PrivateRoute allowedRoles={['ADMIN', 'RH', 'OFFICE']}><FluxoCaixa /></PrivateRoute>} />
            <Route path="/relatorios-contabeis" element={<PrivateRoute><RelatorioContabil /></PrivateRoute>} />
            <Route path="/folha-pagamento" element={<PrivateRoute><FolhaPagamento /></PrivateRoute>} />
            <Route path="/responsavel/dashboard" element={<PrivateRoute allowedRoles={['RESPONSAVEL']} strictRoles><ResponsavelDashboard /></PrivateRoute>} />
            <Route path="/responsavel/frequencia/:matriculaId" element={<PrivateRoute allowedRoles={['RESPONSAVEL']} strictRoles><ResponsavelFrequenciaDetalhe /></PrivateRoute>} />
            <Route path="/acesso-negado" element={<PrivateRoute><AcessoNegado /></PrivateRoute>} />
            <Route path="/perfis" element={<PrivateRoute allowedRoles={['ADMIN']}><PerfisList /></PrivateRoute>} />
            <Route path="/presencas" element={<PrivateRoute><AdminPresencasPage /></PrivateRoute>} />
            <Route path="/configuracoes/financeiro" element={<PrivateRoute allowedRoles={['ADMIN']}><FinancialSettings /></PrivateRoute>} />
            <Route path="/configuracoes/empresa" element={<PrivateRoute allowedRoles={['ADMIN']}><ReceiptIssuerSettings /></PrivateRoute>} />
            <Route path="/conta/assinatura" element={<PrivateRoute allowedRoles={['ADMIN', 'ADMINISTRADOR']}><TenantAccountSubscriptionPage /></PrivateRoute>} />
            <Route path="/platform" element={<PrivateRoute requirePlatformAdmin><PlatformDashboard /></PrivateRoute>} />
            <Route path="/platform/tenant/:id" element={<PrivateRoute requirePlatformAdmin><PlatformTenantDetail /></PrivateRoute>} />
            <Route path="/platform/saas-billing/catalog" element={<PrivateRoute requirePlatformAdmin><PlatformSaasBillingCatalog /></PrivateRoute>} />
            <Route path="/platform/saas-billing/runtime/history" element={<PrivateRoute requirePlatformAdmin><PlatformRuntimeHistory /></PrivateRoute>} />
            <Route path="/platform/saas-billing/runtime/history/executions/:executionId" element={<PrivateRoute requirePlatformAdmin><PlatformRuntimeExecutionDetail /></PrivateRoute>} />
            <Route path="/platform/saas-billing/runtime/executions/:executionId/retry-preview" element={<PrivateRoute requirePlatformAdmin><PlatformRuntimeRetryPreview /></PrivateRoute>} />
            <Route path="/platform/saas-billing/runtime/search" element={<PrivateRoute requirePlatformAdmin><PlatformRuntimeSearch /></PrivateRoute>} />
            <Route path="/platform/saas-billing/runtime/incidents" element={<PrivateRoute requirePlatformAdmin><PlatformRuntimeIncidentsPage /></PrivateRoute>} />
            <Route path="/platform/saas-billing/runtime/cockpit" element={<PrivateRoute requirePlatformAdmin><PlatformRuntimeCockpit /></PrivateRoute>} />
            <Route path="/platform/saas-billing/runtime/provider-config" element={<PrivateRoute requirePlatformAdmin><PlatformRuntimeProviderConfig /></PrivateRoute>} />
            <Route path="/platform/saas-billing/runtime/recovery-operations" element={<PrivateRoute requirePlatformAdmin><PlatformRecoveryOperationsConsole /></PrivateRoute>} />
            <Route path="/platform/saas/subscription-change-requests" element={<PrivateRoute requirePlatformAdmin><PlatformSubscriptionRequestsPage /></PrivateRoute>} />
            <Route path="/platform/saas/timeline" element={<PrivateRoute requirePlatformAdmin><PlatformTenantTimelinePage /></PrivateRoute>} />
            <Route path="/platform/saas/operational-events" element={<PrivateRoute requirePlatformAdmin><PlatformOperationalEventsPage /></PrivateRoute>} />
            <Route path="/platform/saas/operational-health" element={<PrivateRoute requirePlatformAdmin><PlatformOperationalHealthPage /></PrivateRoute>} />
            <Route path="/platform/iam" element={<PrivateRoute requirePlatformAdmin><PlatformIamPage /></PrivateRoute>} />
            <Route path="/platform/saas-billing/operations" element={<PrivateRoute requirePlatformAdmin><PlatformBillingOperationsPage /></PrivateRoute>} />
            <Route path="/platform/saas/subscriptions-dashboard" element={<PrivateRoute requirePlatformAdmin><PlatformSaasSubscriptionsDashboard /></PrivateRoute>} />
            <Route path="/platform/saas/alert-center" element={<PrivateRoute requirePlatformAdmin><PlatformAlertCenterPage /></PrivateRoute>} />
            <Route path="/platform/saas/feature-flags" element={<PrivateRoute requirePlatformAdmin><PlatformFeatureFlagsPage /></PrivateRoute>} />
            <Route path="/platform/saas/go-live-readiness" element={<PrivateRoute requirePlatformAdmin><PlatformGoLiveReadinessPage /></PrivateRoute>} />
            <Route path="/dashboard-executivo-v2" element={<PrivateRoute allowedRoles={['ADMIN']}><DashboardExecutivoV2 /></PrivateRoute>} />
            <Route path="/" element={<Navigate to={defaultRedirect} replace />} />
            <Route path="*" element={<Navigate to={defaultRedirect} replace />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

const App = () => (
  <AuthProvider>
    <VocabularyProvider>
      <AppContent />
    </VocabularyProvider>
  </AuthProvider>
);

export default App;
